import { Link, animateScroll as scroll } from "react-scroll";
import { useTranslation } from "react-i18next";

function Footer() {
  const { t } = useTranslation();
  return (
    <footer>
      <div className="container">
        <div className="row">
          <div className="side1">
            <div className="row">
              <div className="col-md-3">
                <p className="footer-title">{t("footer.services")}</p>
                <ul className="footer-text">
                  <li>
                    <Link to="services" spy={true} smooth={true} duration={800}>
                      <i className="fas fa-code footer-icon" aria-hidden="true"></i>
                      {t("footer.webDevelopment")}
                    </Link>
                  </li>
                  <li>
                    <Link to="services" spy={true} smooth={true} duration={800}>
                      <i className="fas fa-mobile-alt footer-icon" aria-hidden="true"></i>
                      {t("footer.appDevelopment")}
                    </Link>
                  </li>
                  <li>
                    <Link to="services" spy={true} smooth={true} duration={800}>
                      <i className="fas fa-laptop-code footer-icon" aria-hidden="true"></i>
                      {t("footer.softwareDevelopment")}
                    </Link>
                  </li>
                  <li>
                    <Link to="services" spy={true} smooth={true} duration={800}>
                      <i className="fas fa-shield-alt footer-icon" aria-hidden="true"></i>
                      {t("footer.cyberSecurity")}
                    </Link>
                  </li>
                  <li>
                    <Link to="services" spy={true} smooth={true} duration={800}>
                      <i className="fas fa-globe footer-icon" aria-hidden="true"></i>
                      {t("footer.domainRegistration")}
                    </Link>
                  </li>
                </ul>
              </div>
              <div className="col-md-3">
                <p className="footer-title">{t("footer.links")}</p>
                <ul>
                  <li>
                    <Link spy={true} smooth={true} duration={800} to="headerbg">
                      <i className="fas fa-home footer-icon" aria-hidden="true"></i>
                      {t("footer.home")}
                    </Link>
                  </li>
                  <li>
                    <Link to="services" spy={true} smooth={true} duration={800}>
                      <i className="fas fa-briefcase footer-icon" aria-hidden="true"></i>
                      {t("footer.services")}
                    </Link>
                  </li>
                  <li>
                    <Link to="about-scroll" spy={true} smooth={true} duration={800}>
                      <i className="fas fa-users footer-icon" aria-hidden="true"></i>
                      {t("footer.aboutUs")}
                    </Link>
                  </li>
                  <li>
                    <Link to="contact" spy={true} smooth={true} duration={800}>
                      <i className="fas fa-envelope footer-icon" aria-hidden="true"></i>
                      {t("footer.contact")}
                    </Link>
                  </li>
                </ul>
              </div>
            </div>
          </div>
          <div className="side2">
            <div className="row footer-meta-row">
              <div className="col-md-3 footer-col footer-contact">
                <p className="footer-title">{t("footer.contactTitle")}</p>
                <ul>
                  <li>
                    <a className="footer-nowrap" href="mailto:info@dblogcss.com">
                      <i className="fas fa-envelope footer-icon" aria-hidden="true"></i>
                      {t("footer.email")}
                    </a>
                  </li>
                  <li>
                    <a className="footer-nowrap" href="tel:+251112132993">
                      <i className="fas fa-phone-alt footer-icon" aria-hidden="true"></i>
                      {t("footer.mobile")}
                    </a>
                  </li>
                  <li className="footer-address">
                    <i className="fas fa-map-marker-alt footer-icon" aria-hidden="true"></i>
                    <span className="footer-address-text">
                      <span className="footer-nowrap">{t("footer.addressLine1")}</span>
                      <span className="footer-nowrap">{t("footer.addressLine2")}</span>
                    </span>
                  </li>
                </ul>
              </div>
              <div className="col-md-3 footer-col footer-social">
                <p className="footer-title">{t("footer.socialMedia")}</p>
                <ul>
                  <li>
                    <a target="_blank" rel="noreferrer" href="https://www.linkedin.com/in/dblogcss">
                      <i className="fab fa-linkedin-in footer-icon" aria-hidden="true"></i>
                      {t("footer.linkedin")}
                    </a>
                  </li>
                  <li>
                    <a target="_blank" rel="noreferrer" href="https://www.facebook.com/groups/dblogcss">
                      <i className="fab fa-facebook-f footer-icon" aria-hidden="true"></i>
                      {t("footer.facebook")}
                    </a>
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </div>
      <button
        type="button"
        onClick={() => scroll.scrollToTop(800)}
        className="gotop"
        aria-label="Back to top"
      >
        <i className="fas fa-level-up-alt"></i>
      </button>
    </footer>
  );
}

export default Footer;
